<section class="row d-flex align-content-center mt-2">
    <div class="col-4 p-2 border border-white tbl-col rounded-start-1 bg-card text-primary fw-bold text-center">
        {{ "communication.difference.key" | translate }}
    </div>

    <div
        class="p-2 border border-white tbl-col bg-card text-primary fw-bold text-center"
        [class.rounded-end-1]="showOnlyNew()"
        [class.col-6]="showOnlyNew()"
        [class.col-4]="!showOnlyNew()"
    >
        {{ !showOnlyNew() ? ("communication.difference.new_value" | translate) : ("communication.difference.value" | translate) }}
    </div>

    @if (!showOnlyNew()) {
        <div class="col-4 p-2 border border-white tbl-col rounded-end-1 bg-card text-primary fw-bold text-center">
            {{ "communication.difference.old_value" | translate }}
        </div>
    }
    @for (section of config.sections; track section) {
        @switch (section.view) {
            @case ("normal") {
                <adaa-normal-diff-view
                    [isNew]="isNew()"
                    [config]="section"
                    [showOnlyNew]="showOnlyNew()"
                    [newData]="newObject()"
                    [oldData]="oldObject()"
                    [showDIffOnly]="viewOnlyDifferences()"
                />
            }
            @case ("attachment") {
                <adaa-attachment-diff-view
                    [showCustomFields]="true"
                    [showOnlyNew]="showOnlyNew()"
                    [newData]="newObject()?.attachments ?? []"
                    [oldData]="oldObject()?.attachments ?? []"
                    [showDIffOnly]="viewOnlyDifferences()"
                />
            }
        }
    }
</section>
